const actions = {
  SET_STATE: 'user/SET_STATE',
  CREATE: 'disable/CREATE',
   EDIT: 'reason/EDIT',
}

export default actions
